import React from 'react';
import { BrowserSizeProvider } from './BrowserSize';
import { NetworkRoleProvider } from './NetworkRole';
import { UnsavedChangesWarningProvider } from './UnsavedChangesWarning';
import { FeatureFlagsProvider } from './FeatureFlags';
import { CurrentUserProvider } from './CurrentUser';

export function AppProviders({ children }: { children: JSX.Element }) {
  return (
    <CurrentUserProvider>
      <FeatureFlagsProvider>
        <UnsavedChangesWarningProvider>
          <NetworkRoleProvider>
            <BrowserSizeProvider>{children}</BrowserSizeProvider>
          </NetworkRoleProvider>
        </UnsavedChangesWarningProvider>
      </FeatureFlagsProvider>
    </CurrentUserProvider>
  );
}
